// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRegressionCaseWriteDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatRegressionCaseKind } from "./chat-regression-case-kind.enum.gen";
import { ChatRegressionMatchMode } from "./chat-regression-match-mode.enum.gen";
import { ChatRegressionClarifierExpectation } from "./chat-regression-clarifier-expectation.enum.gen";
import { ChatRegressionCaseStatus } from "./chat-regression-case-status.enum.gen";

export const ChatRegressionCaseWriteDtoGenShape = z.strictObject({
  libraryId: z.string(),
  groupId: z.string().optional(),
  input: z.string(),
  kind: z.enum(ChatRegressionCaseKind),
  matchMode: z.enum(ChatRegressionMatchMode),
  expectedAdviceSetIds: z.array(z.string()),
  expectedCrisisFlags: z.array(z.string()),
  expectedTenure: z.string().optional(),
  expectedIssueCount: z.number().optional(),
  tenure: z.string().optional(),
  notes: z.string().optional(),
  userContext: z.string().optional(),
  clarifierExpectation: z.enum(ChatRegressionClarifierExpectation),
  workbenchShortcut: z.boolean(),
  workbenchLabel: z.string().optional(),
  source: z.string().optional(),
  status: z.enum(ChatRegressionCaseStatus),
});
